import React from 'react'
import Typography, { TypographyProps } from '@material-ui/core/Typography'
import styled from 'styled-components'

export interface IStyledTextProp {
  variant?: any
  children: string
  mt?: number
  mr?: number
  mb?: number
  ml?: number
}

const step = 4

const getMargin = (param: number | boolean | undefined): number => {
  if (!param) {
    return 0
  }
  return typeof param === 'number' ? param * step : step
}

const margin = ({ mt, mr, mb, ml }: IStyledTextProp) =>
  `${getMargin(mt)}px ${getMargin(mr)}px ${getMargin(mb)}px ${getMargin(ml)}px`

const StyledTypography = styled(Typography)`
  margin: ${(props: IStyledTextProp) => margin(props)};
` as any

export const StyledText = ({
  variant,
  children,
  ...props
}: TypographyProps & IStyledTextProp) => (
  <StyledTypography variant={variant} {...props}>
    {children}
  </StyledTypography>
)
